import { environment } from "@environment";

/** Hosted in the website bucket of each environment. */
export const onboardingVideoUrl = (name: string) =>
  `${environment.stories}/assets/videos/onboarding/v2/${name}.mp4`;

/**
 * Editor z-layer map (see `menu.tsx` 9996, `settings/Container.tsx` 9996,
 * `ai-storybrain-sidebar` 9997, rail panels 9998, `header.tsx` / shared
 * `Popover.Content` 9999, dialogs 10000+).
 *
 * The tour sits below all of it so every toolbar popup, rail panel and dialog
 * paints over it. It never overlaps chrome because it is anchored beside it.
 */
export const TOUR_Z_INDEX = 9995;

/**
 * For steps that must sit above the right-rail panels instead of below the
 * editor chrome. 9999 clears the rail panels at 9998; it ties with the
 * header and shared `Popover.Content` at 9999, where later DOM order wins,
 * and it still sits below dialogs at 10000+.
 */
export const TOUR_Z_INDEX_ELEVATED = 9999;

/** Marks overlays the tour popover must not be hidden behind. */
export const TOUR_AVOID_ATTR = "data-tour-avoid";
export const TOUR_AVOID_SELECTOR = `[${TOUR_AVOID_ATTR}]`;

/** First-editor-view tracking covers accounts created after this. */
export const RELEASE_PROPERTY_DATE = "2025-07-21 07:00:00";

/**
 * Accounts created at or after this instant get the new onboarding. Mirrors
 * dotell-backend config onboarding.cohortStartsAt, which gates the onboarding
 * and Made-for-you decks.
 */
export const ONBOARDING_COHORT_STARTS_AT = "2026-10-05T00:00:00Z";
